import jwt_decode from "jwt-decode"
import axios from "axios"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import byteSize from "byte-size"
import { URLS } from "../configs/urls"
import queryString from "query-string"
import { gima } from "gima-common"

const MySwal = withReactContent(Swal)

export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */

export const getAppConfig = () => JSON.parse(localStorage.getItem('base_urls'))

export const getPermissionByName = (menuItems, menuName, property = 'func_id') => {
  let can_add = false, can_edit = false, can_delete = false, can_read = false, menu_name = menuName
  for (let key = 0; key < menuItems.length; key++) {
    if (menuItems[key][property] === menuName) {
      can_read = menuItems[key].can_read === 'Y'
      can_add = menuItems[key].can_add === 'Y'
      can_edit = menuItems[key].can_edit === 'Y'
      can_delete = menuItems[key].can_delete === 'Y'
      // menu_name = menuItems[key].func_name.charAt(0).toUpperCase() + menuItems[key].func_name.slice(1).toLowerCase()
      menu_name = menuItems[key].func_name
    } else {
      if (menuItems[key].child_menu && menuItems[key].child_menu.length > 0) {
        for (let keyOne = 0; keyOne < menuItems[key].child_menu.length; keyOne++) {
          if (menuItems[key].child_menu[keyOne][property] === menuName) {
            can_read = menuItems[key].child_menu[keyOne].can_read === 'Y'
            can_add = menuItems[key].child_menu[keyOne].can_add === 'Y'
            can_edit = menuItems[key].child_menu[keyOne].can_edit === 'Y'
            can_delete = menuItems[key].child_menu[keyOne].can_delete === 'Y'
            // menu_name = menuItems[key].child_menu[keyOne].func_name.charAt(0).toUpperCase() + menuItems[key].child_menu[keyOne].func_name.slice(1).toLowerCase()
            menu_name = menuItems[key].child_menu[keyOne].func_name
          } else if (menuItems[key].child_menu && menuItems[key].child_menu[keyOne].child_menu && menuItems[key].child_menu[keyOne].child_menu.length > 0) {
            for (let childKey = 0; childKey < menuItems[key].child_menu[keyOne].child_menu.length; childKey++) {
              if (menuItems[key].child_menu[keyOne].child_menu[childKey][property] === menuName) {
                can_read = menuItems[key].child_menu[keyOne].child_menu[childKey].can_read === 'Y'
                can_add = menuItems[key].child_menu[keyOne].child_menu[childKey].can_add === 'Y'
                can_edit = menuItems[key].child_menu[keyOne].child_menu[childKey].can_edit === 'Y'
                can_delete = menuItems[key].child_menu[keyOne].child_menu[childKey].can_delete === 'Y'
                // menu_name = menuItems[key].child_menu[keyOne].child_menu[childKey].func_name.charAt(0).toUpperCase() + menuItems[key]?.child_menu[keyOne]?.child_menu[childKey]?.func_name?.slice(1).toLowerCase()
                menu_name = menuItems[key].child_menu[keyOne].child_menu[childKey].func_name
              }
            }
          }
        }
      }
    }
  }
  return { can_add, can_edit, can_delete, can_read, menu_name }
}

export const getParamsFromHashUrl = (url) => {
  const [hash, params] = url.split('#')[1].split('?')
  const paramsObj = Object.fromEntries(new URLSearchParams(params))
  return paramsObj
}

export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

export const uuidv4 = () => {
  let d = new Date().getTime()//Timestamp
  let d2 = (performance && performance.now && (performance.now() * 1000)) || 0 //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16//random number between 0 and 16
    if (d > 0) { //Use timestamp until depleted
      r = (d + r) % 16 | 0
      d = Math.floor(d / 16)
    } else { //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0
      d2 = Math.floor(d2 / 16)
    }
    return (c === 'x' ? r : (r && (0x3 || 0x8))).toString(16)
  })
}

export const assignLocalValue = (value) => {
  //console.log(value)
  if (value.startsWith('func')) {
    if (value === 'func.uuid') {
      return uuidv4()
    } else if (value === 'func.date') {
      return moment(new Date).format('YYYY-MM-DD HH:MM:00')
    } else {
      return value
    }
  } else if (value.startsWith('local')) {
    let getForLocal = value.split('.')
    getForLocal = value.replace('local.', '')
    getForLocal = getForLocal.split('.')
    let itemValue = ''
    if (getForLocal.length === 1) {
      itemValue = localStorage.getItem(val)
    } else {
      getForLocal.map((val, index) => {
        if (index === 0) {
          itemValue = JSON.parse(localStorage.getItem(val))
        } else {
          itemValue = itemValue[val]
        }
      })
    }
    return itemValue
  } else {
    return value
  }

}

export const handleVariables = (value) => {
  switch (value) {
    case 'UserName': return assignLocalValue('local.userData.user_name')
    case 'Password': return assignLocalValue('local.userData.password')
    case 'CompanyCode': return assignLocalValue('local.userData.company_code')
    case 'Environment': return assignLocalValue('local.userData.environment')
    case 'JwtToken': return `Bearer ${assignLocalValue('local.userData.jwt_token')}`
    case 'gimaToken': return assignLocalValue('local.userData.gimaToken')
    default: return ''
  }
}

export const isEmpty = (value) => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  )
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

export const parseJwt = (token) => {
  return jwt_decode(token)
}

export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;Path=/calendar`
}

export const getCookie = (cname) => {
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return null
}

export const delete_cookie = (name) => {
  document.cookie = `${name}=; Domain=.a4apple.cn; expires=Thu, 01 Jan 1970 00:00:01 GMT; Path=/`
}

export const siteModeisPRD = !window.location.href.includes("localhost")

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => gima.getToken()
export const loginToken = () => gima.getToken()
export const getUserData = () => gima.getTokenInfo()

const setThemeColor = async () => {
  try {
    const { data } = await axios.get(`${process.env.REACT_APP_GIMA_THEME_API}?companycode=${gima.getCompanyCode() || ""}&environment=${getUserData()?.environment || ""}`)
    if (data) {
      const system_config = data.Data.find((x) => x?.sys_settings?.length > 0)?.sys_settings || []

      localStorage.setItem("companyInfo", JSON.stringify(data?.Data[0]))
      localStorage.setItem("theme_color", data?.Data[0]?.theme_colour)
      localStorage.setItem("system_config", JSON.stringify(system_config || []))
      document.documentElement.style.setProperty(
        '--primary',
        data?.Data[0]?.theme_colour || "#51a351"
      )
    }
  } catch (err) { }
}
setThemeColor()

export const getCompanyConfig = () => {
  const localThemeColor = siteModeisPRD ? gima.getThemeColor() : localStorage.getItem("theme_color")
  if (localThemeColor === "undefined") {
    localStorage.setItem("theme_color", getUserData()?.theme_Color)
    return {
      ...getUserData(), theme_Color: getUserData()?.theme_Color
    }
  }
  return {
    ...getUserData(), theme_Color: localThemeColor
  }
}
/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return '/access-control'
  return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})

export const inIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export const encryptString = (form, string) => {
  const encrypted = CryptoJS.AES.encrypt(
    string,
    CryptoJS.enc.Utf8.parse(form.aeskey),
    {
      iv: CryptoJS.enc.Utf8.parse(form.aesiv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  )
  return encrypted.toString()
}

export const decryptString = (form, string) => {
  const decrypted = CryptoJS.AES.decrypt(string, CryptoJS.enc.Utf8.parse(form.aeskey), {
    iv: CryptoJS.enc.Utf8.parse(form.aesiv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

export const aesEncryption = (form, component, formData) => {
  const newFormData = new FormData()
  for (const pair of formData.entries()) {
    const item = findKey(component, pair[0])
    if (item && item.props && item.props.aesEnable) {
      newFormData.append(pair[0], (pair[1] !== '') ? encryptString(form, pair[1]) : pair[1])
    } else {
      newFormData.append(pair[0], pair[1])
    }
  }
  return newFormData
}

export const getPropByString = (obj, propString) => {
  if (!propString) return obj
  const props = propString.split('.')
  let prop = props
  let i = 0
  const iLen = props.length - 1
  for (i, iLen; i < iLen; i++) {
    prop = props[i]
    const candidate = obj[prop]
    if (candidate !== undefined) {
      obj = candidate
    } else {
      break
    }
  }
  return obj[props[i]]
}

export const parUrlSearchString = (urlQueryString) => {
  const queryStringNew = {}
  for (const key in urlQueryString) {
    if (urlQueryString[key].includes('local')) {
      let getForLocal = urlQueryString[key].split('.')
      getForLocal = urlQueryString[key].replace('local.', '')
      getForLocal = getForLocal.split('.')
      let itemValue = ''
      if (getForLocal.length === 1) {
        itemValue = localStorage.getItem(val)
      } else {
        getForLocal.map((val, index) => {
          if (index === 0) {
            itemValue = JSON.parse(localStorage.getItem(val))
          } else {
            itemValue = itemValue[val]
          }
        })
      }
      queryStringNew[key] = itemValue
    } else if (urlQueryString[key].includes('params')) {
      if (getParameterByName('id')) {
        queryStringNew[key] = getParameterByName('id')
      }
    } else {
      queryStringNew[key] = urlQueryString[key]
    }
  }
  return queryStringNew
}
export const parseUrlPaths = (findPaths) => {
  const paths = []
  findPaths.map((item) => {
    if (item.startsWith('local')) {
      let getForLocal = item.split('.')
      getForLocal = item.replace('local.', '')
      getForLocal = getForLocal.split('.')
      let itemValue = ''
      if (getForLocal.length === 1) {
        itemValue = localStorage.getItem(val)
      } else {
        getForLocal.map((val, index) => {
          if (index === 0) {
            itemValue = JSON.parse(localStorage.getItem(val))
          } else {
            itemValue = itemValue[val]
          }
        })
      }
      paths.push(itemValue)
    } else if (item.includes('params')) {
      let paramSplit = item.split('.')
      paramSplit = paramSplit[paramSplit.length - 1]
      if (getParameterByName(paramSplit)) {
        paths.push(getParameterByName(paramSplit))
      }
    } else {
      paths.push(item)
    }
  })
  return paths
}

export const parseUrltoSend = (url, isHash = false) => {
  const urlParams = {
    userData: gima.getUserData(),
    base_urls: JSON.parse(localStorage.getItem('base_urls'))
  }

  url = url.replace(/params\.(\w+)\b/g, ($, $1) => {
    return getSearchParams($1) || "NotFoundParam"
  })

  url = url.replace(/local\.(\w+)\.(\w+)\b/g, ($, $1, $2) => {
    return urlParams[$1] ? urlParams[$1][$2] : $
  })

  return url
  // if (isUserLoggedIn() || isUserForgotPassword()) {
  //   let unparsedUrl = ''
  //   try {
  //     unparsedUrl = new URL(url)
  //   } catch (e) {
  //     if (url.startsWith('local')) {
  //       const urlSplit = url.includes('?') ? url.substring(0, url.indexOf('?')).split('/') : url.split('/')
  //       const parsedPath = parseUrlPaths(urlSplit)
  //       urlSplit[0] = parsedPath[0]
  //       unparsedUrl = parsedPath.join('/')
  //       if (url.includes('?')) {
  //         unparsedUrl = `${unparsedUrl}?${url.split('?').pop()}`
  //         if (url.includes('staffName:')) {
  //           const urlSpecialSplit = url.substring(0, url.indexOf('staffName:')).split('/')
  //           const parsedSpecialURL = parseUrlPaths(urlSpecialSplit).join("/")
  //           unparsedUrl = `${parsedSpecialURL}staffName:${getUserData().user_name}`
  //         }
  //       }
  //       unparsedUrl = new URL(unparsedUrl)
  //     } else {
  //       unparsedUrl = new URL(`${getAppConfig().gimaApiDomain}${url}`)
  //     }
  //   }
  //   const params = isHash ? getParamsFromHashUrl(unparsedUrl.href) : queryString.parse(unparsedUrl.search)
  //   // const urlQueryString = queryString.parse(params)
  //   const queryStringNew = parUrlSearchString(params)
  //   const parsedUrl = queryString.stringify(queryStringNew)
  //   const finalUrl = new URL(unparsedUrl)
  //   const paths = parseUrlPaths(finalUrl.pathname.split('/'))
  //   // console.log(`${finalUrl.origin}${paths.join('/')}?${parsedUrl}`)

  //   return isHash ? `${finalUrl.href.substring(0, finalUrl.href.indexOf('?'))}?${parsedUrl}` : `${finalUrl.origin}${paths.join('/')}?${parsedUrl}`
  // }
}

export const parseUrlColumnDataWrapper = (urlx, datax) => {
  let parsedurl = ''
  const parseUrlColumnData = (url, data) => {
    if (url.includes('{') && url.includes('}') && (url.indexOf('{') < (url.indexOf('}') - 1))) {
      const replaceItem = url.substring(url.indexOf('{'), url.indexOf('}') + 1)
      const key = url.substring(url.indexOf('{') + 1, url.indexOf('}'))
      parseUrlColumnData(url.replace(replaceItem, data[key]), data)
    } else {
      parsedurl = url
    }
    return parsedurl
  }
  return parseUrlColumnData(urlx, datax)
}

export const resizeFile = (file) => {
  return new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      100,
      100,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri)
      },
      "file"
    )
  })
}

// to display success msg
export const showSuccessMsg = (title, props = {}) => {
  MySwal.fire({
    title,
    icon: "success",
    customClass: {
      confirmButton: "btn btn-inherit"
    },
    confirmButtonText: "Close",
    allowOutsideClick: false,
    confirmButtonColor: gima.getThemeColor(),
    ...props
  })
}

//To display error msg
export const showErrorMsg = (title, htmlData = '') => {
  MySwal.fire({
    title,
    icon: "error",
    customClass: {
      confirmButton: "btn btn-danger"
    },
    buttonsStyling: false,
    allowOutsideClick: false,
    html: `<div style="
    text-align: left;">${htmlData}</div>`
  })
}

export const getSubSystemName = () => localStorage.getItem('SubSystemName') || "CMS"

export const getCompanyInfo = () => {
  const vals = localStorage.getItem("companyInfo")
  return vals && vals !== "null" && vals !== "undefined" ? JSON.parse(localStorage.getItem("companyInfo")) : null
}

export function formatBytes(bytes, decimals = 2) {
  bytes = bytes * 1000 * 1024
  if (!+bytes) return '0B'

  const unit = byteSize(bytes, { unit: "m" })
  return `${unit.value}${unit.unit.toString().toUpperCase()}`
}

function getDocumentHeight() {
  const body = document.body
  const html = document.documentElement

  return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
}

function getScrollTop() {
  return window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
}


export const scrollPagination = (totalCount = 10, currentCount = 1, url, refetchFunc) => (window.onscroll = () => {
  if (getScrollTop() < getDocumentHeight() - window.innerHeight) return
  if (totalCount > currentCount && url === window.location.href) {
    refetchFunc()
  }
})

export const uploadToMediaHandler = (formData) => {
  return new Promise((resolve, reject) => {
    try {
      axios.post(`${URLS.mediaAPI}/media/upload/${URLS.mediaSystem}/${gima.getCompanyCode()}/${gima.getTokenInfo("environment")}`, formData)
        .then((message) => {
          resolve(message)
        })
        .catch((err) => {
          reject(err)
        })
    } catch (err) {
      reject(err)
    }
  })
}

export const getSystemConfig = (key) => {
  if (localStorage.getItem('system_config')) {
    const configValues = JSON.parse(localStorage.getItem('system_config'))
    const findIt = configValues.filter((a) => {
      return a?.sys_key === key
    })
    if (findIt.length === 1) {
      return findIt[0]
    } else {
      return false
    }
  }
  return false
}
export const getDateFormat = (lowCase = false) => {
  let checkFormat = getSystemConfig('dateFormat')?.sys_value
  checkFormat = checkFormat ? checkFormat : 'YYYY-MM-DD'
  if (lowCase) {
    checkFormat = checkFormat.replace('YYYY', 'Y')
    checkFormat = checkFormat.replace('DD', 'd')
    checkFormat = checkFormat.replace('MM', 'm')
  }
  return checkFormat
}

export const downloadFile = async (url = "", name = "") => {
  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error("Failed to fetch the video")
    }
    const blob = await response.blob()

    const blobUrl = URL.createObjectURL(blob)

    const link = document.createElement("a")
    link.href = blobUrl
    link.download = name || url.split('/').pop()

    document.body.appendChild(link)
    link.click()

    link.remove()
    URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error("Error downloading the video:", error)
  }
}